import "bootstrap/dist/css/bootstrap.css"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import configureStore from "./store/configureStore"
import { initializeLocales } from "./locale/lang"
import "bootstrap/dist/css/bootstrap.css"
import "./scss/site.scss"
import { settings } from "./clientAppSettings"
import { logInfo } from "./util/logUtil"

logInfo("Running environment:", settings.env)

export function initialize(Router: (props: any) => JSX.Element | null) {
    // Create browser history to use in the Redux store
    //const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")

    // Get the application-wide store instance, prepopulating with state from the server where available.
    initializeLocales()

    const initialState = window.initialReduxState
    const store = configureStore(initialState)
    const rootElement = document.getElementById("root")

    ReactDOM.render(
        <Provider store={store as any}>
            <Router />
        </Provider>,
        rootElement
    )
}
